import { ROUTES } from '~constants/routes';
import { isManualChoice } from '~utils/flowChoice';

const getManualStepName = clientFinancialInfo =>
  clientFinancialInfo?.employmentSituation ? ROUTES.CLIENT_INCOMES.stepName : ROUTES.LETS_START.stepName;

// ClaveÚnica -> native login; manual -> straight to the forms, starting with the
// labor situation when it is still missing.
export const getStepNameByFlowChoice = clientFinancialInfo => flowChoice =>
  isManualChoice(flowChoice)
    ? getManualStepName(clientFinancialInfo)
    : ROUTES.CLIENT_UNIQUE_KEY_LOGIN.stepName;
